import s from './RootBoundary.module.scss';
import { Link, useRouteError } from 'react-router-dom';
const RootBoundary = () => {
	// let error = useRouteError();
	// console.error(error);

	return (
		<div className={s.rt}>
			<h1>אופס, משהו השתבש</h1>
			<Link to="/" className={s.link}>
				חזרה לעמוד ראשי
			</Link>
		</div>
	);
};
export default RootBoundary;
